export default __webpack_public_path__ + "static/media/home-carousel-arrow-L.5890975e.svg";